export const RECURRENCE_OPTIONS = [
  {
    value: 0,
  },
  {
    value: 1,
  },
  {
    value: 2,
  },
];

export const defaultStartTime = {
  hours: 12,
  minutes: 0,
};

export const defaultByHourTime = 12;

export enum RecurrenceType {
  ByHour = 0,
  Daily = 1,
  Weekly = 2,
}

export enum WeekDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export interface SchedulerDataResponse {
  settings: {
    specifics: {
      scheduler: {
        scheduledDeploy: boolean;
        scheduleType?: number;
        everyHour?: string;
        startTime?: string;
        dayOfWeek?: WeekDays;
      };
    };
  };
}
